<template>
	<el-dialog :visible="visible" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="400px" :center="true" :top="'30vh'">
		<!-- custom-class="invite-code-dialog" -->
		<!-- 标题栏 -->
		<div slot="title" class="dialog-title">
			<h3>邀请码兑换</h3>
			<el-button class="close-btn" type="text" @click="handleClose">
				<i class="el-icon-close"></i>
			</el-button>
		</div>

		<!-- 主要内容 -->
		<div class="dialog-content">
			<el-form ref="formRef" :model="formData" :rules="rules" label-width="0">
				<el-form-item prop="inviteCode">
					<el-input v-model.trim="formData.inviteCode" placeholder="请输入邀请码" maxlength="20" clearable @keyup.enter.native="handleSubmit" size="medium">
						<template slot="prefix">
							<i class="el-icon-key"></i>
						</template>
					</el-input>
				</el-form-item>
			</el-form>

			<!-- <div class="dialog-tips">
				<i class="el-icon-info"></i>
				<span>请输入有效的邀请码进行兑换</span>
			</div> -->
		</div>

		<!-- 底部按钮 -->
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="handleClose">取消</el-button>
			<el-button type="primary" size="medium" :loading="loading" @click="handleSubmit">确认兑换</el-button>
		</div>
	</el-dialog>
</template>

<script>
import TMessage from '@/utils/TMessage';
import { getConsumerOrderExchangeInviteCode, getConsumerOrderQueryVipCode } from '@/api/order/order.js';

export default {
	name: 'DialogInviteCode',
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		// 邀请码验证规则
		const validateInviteCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入邀请码'));
			}
			// if (value.length < 2) {
			// 	return callback(new Error('邀请码长度不能少于6位'));
			// }
			// if (!/^[A-Za-z0-9]+$/.test(value)) {
			// 	return callback(new Error('邀请码只能包含字母和数字'));
			// }
			callback();
		};

		return {
			loading: false,
			formData: {
				inviteCode: ''
			},
			rules: {
				inviteCode: [{ required: true, validator: validateInviteCode, trigger: 'blur' }]
			}
		};
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				// 弹框打开时重置表单
				this.$nextTick(() => {
					if (this.$refs.formRef) {
						this.$refs.formRef.resetFields();
					}
				});
			}
		}
	},
	methods: {
		// 关闭弹框
		handleClose() {
			this.$emit('update:visible', false);
		},

		// 提交表单
		async handleSubmit() {
			// 表单验证
			const valid = await this.$refs.formRef.validate().catch(() => false);
			if (!valid) return;

			getConsumerOrderQueryVipCode(this.formData.inviteCode).then(res => {
				if (res.code == 200) {
					// 显示二次确认框
					if (res.data == 0) {
						this.$message.error('邀请码无效，请重新输入');
						return
					}
					this.$confirm('确认兑换此邀请码吗？兑换后, 您将获得 <span style="color: red;">'+res.data +'个月</span> VIP会员，体验更多功能和权限!', '提示', {
						confirmButtonText: '确认兑换',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					})
						.then(() => {
							// 用户确认兑换
							this.exchangeInviteCode();
						})
						.catch(() => {
							// 用户取消兑换
							// TMessage.info('已取消兑换');
						});
				} else {
					this.$message.error(res.msg);
				}
			});
		},

		// 兑换邀请码
		async exchangeInviteCode() {
			this.loading = true;
			try {
				// 这里调用兑换邀请码的API
				getConsumerOrderExchangeInviteCode(this.formData.inviteCode).then(res => {
					if (res.code == 200) {
						this.handleClose();
						this.$emit('success');
					} else {
						TMessage.error(res.msg || '兑换失败，请检查邀请码是否正确');
					}
				});
			} catch (error) {
				TMessage.error(error.message || '兑换失败，请检查邀请码是否正确');
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="less" scoped>
// 弹框样式
:deep(.invite-code-dialog) {
	.el-dialog {
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

		.el-dialog__header {
			padding: 0;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			position: relative;
		}

		.el-dialog__body {
			padding: 30px 20px 20px;
		}

		.el-dialog__footer {
			padding: 0 20px 20px;
		}
	}
}

// 标题栏样式
.dialog-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	// padding: 20px;
	color: #303133;

	h3 {
		margin: 0;
		font-size: 18px;
		font-weight: normal;
	}

	.close-btn {
		color: #303133;
		font-size: 18px;

		&:hover {
			color: rgba(48, 49, 51, 0.8);
			// background-color: rgba(255, 255, 255, 0.1);
		}
	}
}

// 内容区域样式
.dialog-content {
	margin: -20px -5px;
	.dialog-tips {
		display: flex;
		align-items: center;
		margin-top: 15px;
		padding: 10px;
		background-color: #f0f9ff;
		border-radius: 6px;
		border-left: 4px solid #409eff;

		i {
			color: #409eff;
			margin-right: 8px;
			font-size: 16px;
		}

		span {
			color: #606266;
			font-size: 13px;
		}
	}
}

// 底部按钮样式
.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 12px;

	.el-button {
		// min-width: 100px;
		border-radius: 6px;

		&:first-child {
			border: 1px solid #f1f5f9;

			&:hover {
				border-color: #409eff;
				color: #409eff;
			}
		}
	}
}

// 输入框样式
:deep(.el-input) {
	// .el-input__inner {
	// 	height: 44px;
	// 	line-height: 44px;
	// 	border-radius: 8px;
	// 	font-size: 16px;

	// 	&:focus {
	// 		border-color: #409EFF;
	// 	}
	// }

	.el-input__prefix {
		left: 12px;

		.el-icon-key {
			color: #c0c4cc;
			// font-size: 18px;
			// line-height: 44px;
		}
	}
}

// 响应式设计
@media (max-width: 480px) {
	:deep(.invite-code-dialog) {
		.el-dialog {
			width: 90% !important;
			margin: 0 auto;
		}
	}

	.dialog-footer {
		flex-direction: column;

		.el-button {
			width: 100%;
			margin: 0;

			&:first-child {
				margin-bottom: 10px;
			}
		}
	}
}
</style>